export const getProductTitleFromVariant = (products, variant) => {
	const findProduct = products?.find(product => product?.shopifyId === variant?.productId);

	return findProduct?.shortTitle || '';
}